import type { UserError } from "@shopify/hydrogen-react/storefront-api-types";

export enum ReturnReason {
  DEFAULT = "DEFAULT",
  DEFECTIVE = "DEFECTIVE",
  UNWANTED = "UNWANTED",
  WRONG_ITEM = "WRONG_ITEM",
  SIZE_TOO_LARGE = "SIZE_TOO_LARGE",
  SIZE_TOO_SMALL = "SIZE_TOO_SMALL",
  OTHER = "OTHER",
}

export type TReturnReason =
  | typeof ReturnReason.DEFAULT
  | typeof ReturnReason.DEFECTIVE
  | typeof ReturnReason.UNWANTED
  | typeof ReturnReason.WRONG_ITEM
  | typeof ReturnReason.SIZE_TOO_LARGE
  | typeof ReturnReason.SIZE_TOO_SMALL
  | typeof ReturnReason.OTHER;

export interface IReturnLineItem {
  fulfillmentLineItemId: string;
  quantity: number;
  returnReason: TReturnReason | string;
  customerNote: string;
}

export interface IProps {
  shop: string;
  domain?: "kr" | "intl" | "";
  orderId: string;
  returnLineItems: IReturnLineItem[];
  returnImageUrls: string[];
  returnShippingFee: number;
}

export interface IRefundLineItem {
  returnLineItemId: string;
  quantity: number;
}

export enum RefundType {
  FULL = "FULL",
  PROPORTIONAL = "PROPORTIONAL",
}

export interface IRefundDuty {
  dutyId: string;
  refundType: RefundType;
}

export interface IRequestReturnResponse {
  returnId: string;
  returnRefundLineItems: IRefundLineItem[];
  refundDuties: IRefundDuty[];
  userErrors?: UserError[];
}

/**
 * 반품 리뉴얼이 완료된 '예스아이씨', '네버댓', '카키스' 에서 사용함
 * refundDuties를 추가로 반환해주는 경우만 다르고 나머지 로직은 requestReturn 와 동일함
 * */
export const requestReturn = async ({
  shop,
  domain = "",
  orderId,
  returnLineItems,
  returnImageUrls,
  returnShippingFee,
}: IProps): Promise<IRequestReturnResponse | undefined> => {
  //common_return_request_v2
  const lambdaUrl = "https://m5uguvf75yvezp3wdbqwg2de6q0mswvg.lambda-url.ap-northeast-2.on.aws/";

  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({
        shop,
        orderId,
        returnLineItems,
        returnImageUrls,
        domain,
        returnShippingFee,
      }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IRequestReturnResponse;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};

/**
 * '웰빙'에서만 사용중
 * customeAttributes를 업데이트해주는 로직 추가됨
 * */
export const requestReturnV2 = async ({
  shop,
  domain = "",
  orderId,
  returnLineItems,
  returnImageUrls,
  returnShippingFee,
}: IProps): Promise<IRequestReturnResponse | undefined> => {
  // common_return_request_v3
  const lambdaUrl = "https://l6u2aq4u2oqs53kllcecoqyzya0jobbp.lambda-url.ap-northeast-2.on.aws/";

  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({
        shop,
        orderId,
        returnLineItems,
        returnImageUrls,
        domain,
        returnShippingFee,
      }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IRequestReturnResponse;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
